//设备台账

import request from '@/util/request';

//新增设备记录
export const addDevice = (params, options) =>
request.post('/api/device/deviceAccountSave', params,options)
//编辑设备记录
export const updateDevice = (params, options) =>
request.post('/api/device/updateToDevice', params,options)

//合同记录
export const getContractByDeviceId = (params, options) =>
request.get('/api/device/getContractByDeviceId', Object.assign({}, options, { params }))

//获取设备信息
export const getDetailByDeviceId = (params, options) =>
request.get('/api/device/getDetailByDeviceId', Object.assign({}, options, { params }))

//关联合同
export const addContract = (params, options) =>
request.post('/api/device/addContract', params,options)

//移除合同
export const removeContract = (ids) =>
request.post('/api/device/removeContract?ids='+ids)

//关联标准
export const addInspectAndUpkeep = (params, options) =>
request.post('/api/device/addInspectAndUpkeep', params,options)

//关联巡检
export const addInspect = (params, options) =>
request.post('/api/device/addInspect', params,options)
//管理维保
export const addUpkeep = (params, options) =>
request.post('/api/device/addUpkeep', params,options)

//新增设备维保记录
export const saveDeviceUpkeep = (params, options) =>
request.post('/api/device/saveDeviceUpkeep', params,options)
//设备维保记录查看
export const getDeviceKeepRecord = (params, options) =>
request.get('/api/upkeeptasklist/upkeepDetail', Object.assign({}, options, { params }))
